export default __webpack_public_path__ + "static/media/Savant's Wristbands of the Effulgent Blade.43c3501b.jpg";